module.exports = __webpack_public_path__ + "img/talk-orange.bbf2c6a.png";